import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import ButtonLink from "../btn-collections/btn-collections.component"

export const PageHeroStraplineGrid = styled.div`

  @media only screen and (max-width: 930px) {
    margin-bottom: 0;
  }  
`

export const LongHeader = styled.div`

@media only screen and (min-width: 931px) {
  width: 550px;
}

@media only screen and (min-width: 931px) and (max-width: 1281px) {
    display: none;
  }

  line-height: 54px;
  font-size: 42px;
  color: ${({ theme: { colors } }) => colors.black};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  margin-top: 5px;
  margin-bottom: 40px;
  text-align: left;

  span {
    color: ${({ theme: { colors } }) => colors.accentPink};
  }

  @media only screen and (max-width: 930px) {
    line-height: 46px;
    font-size: 36px;
  }

  @media only screen and (max-width: 780px) {
    margin-top: 5px;
    margin-bottom: 25px;
  }

  @media only screen and (max-width: 500px) {
    display: none;
  }

  @media only screen and (max-width: 401px) {
    height: 178px;
  }


`

export const PageHeader = styled.div`

/* Show only between 931px and 1030px */
  display: none;

  @media only screen and (min-width: 931px) and (max-width: 1281px) {
    display: block;
  }
  line-height: 54px;
  font-size: 42px;
  color: ${({ theme: { colors } }) => colors.black};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  margin-top: 5px;
  margin-bottom: 40px;
  text-align: left;

  span {
    color: ${({ theme: { colors } }) => colors.accentPink};
  }

  @media only screen and (max-width: 930px) {
    line-height: 46px;
    font-size: 36px;
  }

  @media only screen and (max-width: 780px) {
    margin-top: 5px;
    margin-bottom: 20px;
  }

   @media only screen and (max-width: 500px) {
    display: block;
    height: 95px;
  }

  @media only screen and (max-width: 420px) {
    height: 140px;
  }
`

export const CircularImageWrapper = styled.div`
  width: 35px;
  height: 35px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  margin-right: -15px;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .gatsby-image-wrapper img {
    bottom: 0;
    height: 100%;
    left: 0;
    margin: 0;
    max-width: none;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;

export const AvatarImages = styled(GatsbyImage)`
  height: 35px;
  width: 35px;
  border-radius: 50%;
  margin-right: -15px;
  border: 2px solid white;
`

export const TopCopyContainer = styled.div`
  text-align: left;
  margin-left: 25px;
  margin-top: 3px;
  ${({ theme: { typography } }) => typography.desktop.metadata};

  @media only screen and (max-width: 930px) {
    ${({ theme: { typography } }) => typography.mobile.metadata};
  }
`

export const HeaderBulletsContainer = styled.div`

  @media only screen and (min-width: 931px) and (max-width: 1217px) {
    display: none;
  }

  text-align: left;
  margin-bottom: 25px;

  @media only screen and (max-width: 1217px) {
    margin-bottom: 20px;
  }
`

export const AvatarFlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media only screen and (max-width: 391px) {
    align-items: flex-start;
  }
`

export const FlexContainer = styled.div`
  display: flex;
`

export const HeaderBullets = styled.p`
  ${({ theme: { typography } }) => typography.desktop.body};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  color: ${({ theme: { colors } }) => colors.darkGrey};
  margin-bottom: 20px;

  @media only screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.body};
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
    color: ${({ theme: { colors } }) => colors.darkGrey};
  }
`

export const ShortBulletsContainer = styled.div`
  /* Show ShortBulletsContainer only between 931px and 1216px */
  display: none;

  @media only screen and (min-width: 931px) and (max-width: 1217px) {
    display: block;
    margin-bottom: 25px;
  }
`;


export const BottomContentContainer = styled.div`
  height: 200px;
  width: 550px;

  @media only screen and (max-width: 1400px) {
    display: flex;
    flex-direction: column;
    width: 500px;
  }

  @media only screen and (max-width: 1217px) {
    width: 375px;
  }

  @media only screen and (max-width: 930px) {
    width: 100%;
    height: auto;
  }
`

export const PageHeroButtonContainer = styled.div`
  display: flex;
  margin: auto;
  align-items: center;
  margin-bottom: 18px;
  gap: 10px;

  @media only screen and (max-width: 1400px) {
    flex-direction: column;
    margin: 0;
  }

  @media only screen and (max-width: 930px) {
    flex-direction: row;

  }

  @media only screen and (max-width: 630px) {
    flex-direction: column;
    
    & a {
      padding: 0;
      width: 100%;
    }

  }

   @media only screen and (max-width: 500px) {
    flex-direction: column;
  }

`

export const ExploreCoursesButton = styled(ButtonLink)`
  @media only screen and (max-width: 1400px) and (min-width: 931px) {
    width: 275px;
  }
`

export const TrustPilotContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 30px;
  margin-left: -10px;

  @media only screen and (max-width: 1400px) {
    margin-left: 0;
    justify-content: center;
  }

  @media only screen and (max-width: 930px) {
    width: 568px;
  }

  @media only screen and (max-width: 663px) {
    justify-content: center;
    margin-left: -7px;
    width: 100%;
  }

  @media only screen and (max-width: 450px) {
    justify-content: flex-start;
    margin-left: 7px;
    width: 100%;
  }

  @media only screen and (max-width: 450px) {
    justify-content: center;
    margin-left: 0;
  }
`
